import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { ctaPurpleRight } from '../../../../../../assets/hostedassets';
import Tooltip from '../../../../../../common/_custom/Tooltip/Tooltip';
import { setShowAicaGradeDrawer } from '../../../../../../store/dashboard/actions';
import AicaGradeBar from './AicaGradeBar/AicaGradeBar';
import AicaGradeSideDrawer from './AicaGradeSideDrawer/AicaGradeSideDrawer';
import styles from './AICAGradev2.module.scss';
import MetricRiskBadge from './MetricRiskBadge/MetricRiskBadge';
import infoIcon from '../../../../../../assets/info.svg';
import { reportSectionsToShow } from '../../../../../AicaPDFReport/AicaPDFReport';
import { REPORT_SECTION_NAMES } from '../../../../../../store/pdfReport/pdfReport_constants';
import A4Page from '../../../../../AicaPDFReport/A4Page/A4Page';
import clsx from 'clsx';

function AICAGradeV2({ isPDFReport = false }) {
    const dispatch = useAppDispatch();
    const aicaGradeData = useAppSelector((state) => state.dashboard.dashboardReducer.aicaGradeData);
    const metricScoreGenerated = aicaGradeData.metricScoreGenerated;
    const companyGrade = aicaGradeData.companyGrade;
    const gradeUnavailable = companyGrade === null;
    const isLoading = aicaGradeData.isLoading;

    function getGradeDisplayValue() {
        if (!aicaGradeData.companyGrade || aicaGradeData.companyGrade === 'Unrated') return null;
        return aicaGradeData.companyGrade;
    }

    const showRiskParameters = () => {
        dispatch(setShowAicaGradeDrawer(true));
    };

    const renderRiskParametersButton = () => {
        return (
            <button className={styles.viewButton} onClick={showRiskParameters}>
                <img src={ctaPurpleRight} alt="" className={styles.viewButtonIcon} />
                View Risk Parameters
            </button>
        );
    };

    if (!metricScoreGenerated) return <></>;
    const render = (
        <div className={clsx(styles.AICAGrade, { [styles.PDFReport]: isPDFReport })}>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <h2 className={styles.heading}>Risk Grade</h2>
                </div>
                {/* View Risk Parameters button is intentionally shown on all views (including PDF) */}
                <div className={styles.headerRight}>{renderRiskParametersButton()}</div>
            </div>

            <div className={styles.content}>
                <div className={styles.description}>
                    Indicates creditworthiness, calculated by aggregating scores across parameters.{' '}
                    <span className={styles.learnMore} onClick={showRiskParameters}>
                        Learn more
                    </span>
                </div>
                <AicaGradeBar grade={aicaGradeData.companyScore} isPDFReport={isPDFReport} />
                <div className={styles.metricsSection}>
                    {aicaGradeData?.headers?.map((data, i) => (
                        <div className={styles.metricRow} key={`${data?.displayName}-${i}`}>
                            <div className={styles.metricName}>
                                {data?.displayName}
                                {!!data?.tooltipDescription && !isPDFReport && (
                                    <Tooltip
                                        content={data.tooltipDescription}
                                        direction="left"
                                        usePortal={true}
                                        style={{ width: '15.625rem' }}
                                    >
                                        <img src={infoIcon} alt="score" className={styles.infoIcon} />
                                    </Tooltip>
                                )}
                            </div>
                            <div className={styles.metricValue}>
                                <MetricRiskBadge score={data?.headerScore} isPDFReport={isPDFReport} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <AicaGradeSideDrawer
                showDrawer={aicaGradeData.showAicaGradeDrawer}
                closeDrawer={() => {
                    dispatch(setShowAicaGradeDrawer(false));
                }}
            />
        </div>
    );

    if (isPDFReport)
        return metricScoreGenerated && reportSectionsToShow.includes(REPORT_SECTION_NAMES.AICA_GRADE) ? (
            <A4Page sectionName={REPORT_SECTION_NAMES.AICA_GRADE}>
                {render}
                <AicaGradeSideDrawer isPDFReport />
            </A4Page>
        ) : (
            <></>
        );
    else return render;
}

export default AICAGradeV2;
